import React, { useState } from "react";
import Logo from "../../svg/logo.svg";
import { FormControl, FormGroup, FormLabel, FormControlLabel, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "./Contact.scss";
import { notificationService } from "../../services/Notifications/Notifications";
import axios from 'axios';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%"
  }
}));

const Contact = ({ receiverEmail }) => {
  const classes = useStyles();

  const [state, setState] = useState({
    name: "",
    email: "",
    message: "",
    datenschutz: false,
    agb: false
  });

  const [validationErrors, setValidationErrors] = useState({
    email: {
      valid: true,
      label: ""
    }
  });

  const handleChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    setState({ ...state, [name]: value });
  };

  const validateEmail = () => {
    setValidationErrors({
      ...validationErrors,
      email: { ...validationErrors.email, label: "", valid: true }
    });

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!pattern.test(state.email)) {
      setValidationErrors({
        ...validationErrors,
        email: {
          ...validationErrors.email,
          label: "Bitte gib eine gültige E-Mail Adresse ein.",
          valid: false
        }
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (!state.datenschutz) {
      notificationService.error("Bitte Datenschutz akzeptieren um fortzusetzen");
      return;
    }

    let { name, email, message, agb, datenschutz } = state;
    let data = { receiverEmail, name, email, message, agb, datenschutz };

    axios.post("/.netlify/functions/sendEmail", JSON.stringify(data)).then(response => {
      if (response.status !== 200) {
        handleError();
      } else {
        handleSuccess();
      }
    });
  };

  const handleSuccess = () => {
    setState({
      name: "",
      email: "",
      message: "",
      agb: false,
      datenschutz: false,
      loading: false,
      error: false
    });

    notificationService.success("Deine E-Mail ist bei uns angekommen. Vielen Dank!");
  };

  const handleError = msg => {
    setState({
      ...state,
      loading: false,
      error: true,
      msg
    });

    notificationService.error("Es ist ein fehler aufgetreten. Bitte versuche es nocheinmal.");
  };

  return (
    <section className="contact" id="kontakt">
      <div className="contact--card card">
        <div className="contact--grid">
          <h1 className="contact--header">Kontakt</h1>
          <div className="contact--logo">
            <Logo />
          </div>

          <form name="contact" onSubmit={handleSubmit} className="contact--form contactForm--grid">
            <p className="form-field contact--name">
              <label htmlFor="name" className="control-label">
                <span className="label">Dein Name</span>
                <input
                  type="text"
                  name="name"
                  required="required"
                  value={state.name}
                  onChange={handleChange}
                />
              </label>
            </p>

            <p className="form-field contact--email">
              <label htmlFor="email" className="control-label">
                <span className="label">E-Mail</span>
                <input
                  type="email"
                  name="email"
                  required="required"
                  value={state.email}
                  onChange={handleChange}
                  onBlur={validateEmail}
                />
              </label>
              <span className="clinicsInfo__validation--error">{validationErrors.email.label}</span>
            </p>

            <p className="form-field contact--message">
              <span htmlFor="message" className="label">
              Deine Nachricht
              </span>
              <textarea
                required="required"
                rows="10"
                name="message"
                value={state.message}
                onChange={handleChange}
              />
            </p>

            <FormControl component="fieldset" className={`${classes.formControl}`}>
              <FormLabel component="legend">
                {/* TODO: use dynamic version */}
                Ich stimme zu, dass meine Angaben aus dem Kontaktformular zur Beantwortung meiner
                Anfrage erhoben und verarbeitet werden. Die Daten werden nach abgeschlossener
                Bearbeitung Ihrer Anfrage umgehend gelöscht. Detaillierte Informationen zum Umgang
                mit Nutzerdaten finden Sie in unserer Datenschutzerklärung. *
              </FormLabel>
              <FormGroup className={`${classes.contact} legal`}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.datenschutz}
                      onChange={() => setState({ ...state, datenschutz: !state.datenschutz })}
                      name="datenschutz"
                    />
                  }
                  label="Datenschutz *"
                />

              </FormGroup>
            </FormControl>

            <button className="contact--submit button" type="submit">
              Senden
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
